import styled, { css } from 'styled-components';

import { SCREEN } from '../../../../assets/styles/constants';
import { Colors, ColorsVariables } from '../../../../assets/styles/colors';
import { flex } from '../../../../assets/styles/flex-grid';

export const YambWrapper = styled.div`
	margin-right: 60px;
	.custom-tooltip-class{
		background-color: white !important;
		color: #454959 !important;
		font-size: 12px !important;
		box-shadow: 0px 0px 34px -4px rgba(0,0,0,0.15);
		max-width: 130px;
		padding: 5px 3px 3px 3px !important;
		opacity: 1 !important;
	}
	.custom-tooltip-class-with-content{
		background-color: white !important;
		color: #454959 !important;
		font-size: 12px !important;
		box-shadow: 0px 0px 34px -4px rgba(0,0,0,0.15);
		padding: 10px !important;
		opacity: 1 !important;
		@media (min-width: 1020px){
			padding: 20px !important;
			font-size: 18px !important;
		}
	}
	${SCREEN.MEDIUM} {
		margin-right: 0;
	}
`;

export const ResetGame = styled.button`
	font-size: 18px;
	cursor: pointer;
	margin: 100px auto 0 auto;
	color: rgb(118, 216, 161);
	opacity: 0.8;

	:hover {
		opacity: 1;
	}

	${SCREEN.MEDIUM}{
		margin: unset;
	}
`;

export const TableWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;

	${props => props.singlePlayer && css`
		justify-content: space-evenly;
		flex-wrap: wrap;
		> div:first-child {
			${SCREEN.MEDIUM} {
				margin-bottom: 0;
			}
		}
	`};

	${props => !props.singlePlayer && css`
		${SCREEN.MEDIUM} {
			flex-direction: column;
		}
		
		> div:first-child {
			${SCREEN.MEDIUM} {
				flex-direction: column;
			}
		}
	`};
`;

export const DiceWrapper = styled.div`
	width: 370px;
	margin: 0 auto 30px;
	display: flex;
	justify-content: space-around;
	align-items: center;
	
	${props => !props.turn && css`
		opacity: 0.5;
	`}

	${SCREEN.MEDIUM} {
		margin: unset;
		width: 320px;
	}
	${SCREEN.SMALL} {
		width: unset;
		flex: 4;
		font-size: 32px;
	}
`;

const disable = css`
	opacity: 0.2;
	pointer-events: none;
	
	&:hover {
		opacity: 0.2;
		box-shadow: none;
	}
`;

export const RollButton = styled.button`
	font-size: 24px;
	cursor: pointer;
	transition: all 0.1s linear;
	font-weight: 700;
	padding: 0px 25px;
	border: 2px solid ${ColorsVariables.MainGreen};
	border-radius: 4px;
	color:  ${ColorsVariables.MainGreen};
	opacity: 0.6;
	${props => props.rolling && css`
		opacity: 1;
		box-shadow: 0 2px 8px 2px rgba(0, 0, 0, 0.31) !important;
	`}
	svg {
		font-size: 18px;
		${SCREEN.MEDIUM} {
			display: none;
		}
	}
	&:hover {
		box-shadow: 0 2px 11px 2px rgba(0, 0, 0, 0.11);
		opacity: 1;
	}

	${props => props.disable && disable}
`;

export const PingPlayer = styled.button`
	color: #1FC2EA;
	margin-left: auto;
	display: block;
	&:hover {
		cursor: pointer;
		text-decoration: underline;
	}
	
	${SCREEN.MEDIUM} {
		padding: unset;
		margin: 0 5px 0 auto; 
		svg {
			position: static;
		}
	}
`;

// Move to new a molecule (InvitePlayer)
export const InvitePlayerWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	align-items: flex-end;
	z-index: 2;
	margin-bottom: 10px;
	${SCREEN.SMALL}{
		margin-bottom: unset;
	}
	h1 {
		padding-top: 20px;
	}
`;

export const InviteAPlayer = styled.button`
	padding: 10px 12px;
	font-size: 18px;
	border-radius: 3px;
	${Colors.MainGreen};
	font-weight: bold;
	transition: all 0.2s ease-in-out;
	width: fit-content;
	border: 2px solid  #a7dcd8;
	cursor:pointer;
	
	&:hover {
		border: 2px solid ${ColorsVariables.MainGreen};
		box-shadow: 0 2px 11px 2px  #a7dcd8;
	}
	${SCREEN.SMALL}{
		align-self: flex-end;
		font-size: 16px;
		padding: 8px 4px;
		height: 100%;
		border-width: 1px;
	}
`;

// Opponent connection component
export const PlayersWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-right: 60px;

	${SCREEN.MEDIUM} {
		padding: unset;
		align-items: center;
		margin: 0 0 10px 0;
		justify-content: center;
	}
	${SCREEN.SMALL}{
		display: none;
	}
`;

export const OpponentConnectionWrapper = styled.div`
	
	.green {
		${Colors.MainGreen};
	}
	
	.red {
		${Colors.MainRed};
	}
	${SCREEN.MEDIUM} {
		display: none;
		${props => props.show && 'display: unset;'};
	}
`;

export const TurnNotifierWrapper = styled.div`
	align-self: center;
	font-size: 16px;
	white-space: nowrap;
	
	${SCREEN.SMALL} {
		min-height: unset;
		top: -10px;
		position: absolute;
		left: 47%;
		margin-right: 10px;
		transform: translate(-50%);
	}
	.green {
		${Colors.MainGreen};
	}
	
	.red {
		${Colors.MainRed};
	}
`;

export const RollsWrapper = styled.div`
	display: flex;
	justify-content: space-evenly;
	flex-wrap: wrap;
	align-items: center;
	margin: 20px auto;
	max-width: 100px;
	color: #D8D8D8;
	
	span {
		width: 16px;
		height: 16px;
		border-radius: 10px;
		border: 4px solid #D8D8D8;
		font-size: 8px;
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	${SCREEN.SMALL} {
		max-width: unset;
		margin: unset;
	}

	svg {
		${SCREEN.SMALL} {
			margin-top: 4px;
			height: 12px !important;
			width: 12px !important;
		}
	}
	.green {
		color: ${ColorsVariables.MainGreen}
	}
`;

export const TableContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-self: flex-start;
	position: relative;
	${props => props.enemyTable && 'order: 2;'}
	${SCREEN.SMALL}{
		${props => props.enemyTable && 'display: none;'}
	}
	${props => props.endOfTheGame && 'display: flex !important;'};
	${props => props.endOfTheGame && props.enemyTable && 'order: 3 !important;'};
	${SCREEN.MEDIUM} {
		align-self: center;
	}
	.enemy-board{
		
	}
`;

export const MiddleSectionWrapper = styled.div`
	${flex};
	flex-direction: column;
	align-self: flex-start;
	order: 0;
	${SCREEN.MEDIUM} {
		order: -1;
		width: 100%;
	}
`;

export const GreenText = styled.span`
	color: #1FA59A;
	font-size: 24px;
	font-weight: bold;
	${SCREEN.SMALL}{
		font-size: 18px;
		${props => props.smaller && css`font-size: 14px;`};
	}
`;

export const RedText = styled(GreenText)`
	color: #DD1818;
`;

export const GreenButton = styled.button`
	
	padding: 10px 25px;
	font-size: 18px;
	border: 1px solid ${ColorsVariables.MainGreen};
	color: ${ColorsVariables.MainGreen};
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 3px;
`;

export const GameMiddleSectionWrapper = styled.div`
	height: 550px;
	display: flex;
	flex-direction: column;
	align-self: flex-start;
	order: 1;
	${props => props.singlePlayer && 'margin-top: 50px'};
	${props => props.singlePlayer && 'height: 500px'};
	${props => props.justifyContent && `justify-content: ${props.justifyContent}`};
	${SCREEN.MEDIUM} {
		width: 100%;
		height: unset;
		margin-top: 20px;
		${ResetGame}{
			display: none;
		}
	}
	${SCREEN.SMALL}{
		width: 100%;
		height: unset;
		position: fixed;
		bottom: 0;
		background: white;
		z-index: 2;
		box-shadow: 0 2px 4px 2px rgba(0, 0, 0, .4);
	}
`;

GameMiddleSectionWrapper.defaultProps = {
	justifyContent: 'space-between',
};

export const ControlsContainer = styled.div`
	
	${SCREEN.SMALL} {
		display: flex;
		justify-content: space-evenly;
		padding: 10px 5px;
	}
`;
export const RollingButtonWrapper = styled.div`
	${SCREEN.SMALL} {
		flex: 1;
	}
`;
export const RedOpponentTextMobile = styled(RedText)`
	display: none;
	font-size: 14px;
	${SCREEN.SMALL}{
		display: block;
	}
	text-align: left;
`;
